import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminNewsManager.css";

const AdminNewsManager = () => {

  const [news, setNews] = useState([]);

  const [form, setForm] = useState({
    title: "",
    description: "",
    news_date: "",
  });

  const [image, setImage] = useState(null);
  const [editId, setEditId] = useState(null);


  const loadNews = async () => {
    const res = await axios.get("/api/news");
    setNews(res.data);
  };


  useEffect(() => {
    loadNews();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();

    data.append("title", form.title);
    data.append("description", form.description);
    data.append("news_date", form.news_date);

    if (image) data.append("image", image);

    if (editId) {
      await axios.put(`/api/news/${editId}`, data);
    } else {
      await axios.post("/api/news", data);
    }

    resetForm();
    loadNews();
  };


  const editNews = (n) => {

    setForm({
      title: n.title,
      description: n.description,
      news_date: n.news_date,
    });

    setEditId(n.id);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  const deleteNews = async (id) => {
    if (window.confirm("Delete this news?")) {
      await axios.delete(`/api/news/${id}`);
      loadNews();
    }
  };


  /* FIXED RESET FUNCTION */

  const resetForm = () => {
    setForm({
      title: "",
      description: "",
      news_date: "",
    });

    setImage(null);
    setEditId(null);
  };


  return (
    <div className="news-admin">

      <h2>News Manager</h2>

      <form onSubmit={handleSubmit} className="news-form">

        <input
          type="text"
          placeholder="Title"
          value={form.title}
          onChange={(e) =>
            setForm({ ...form, title: e.target.value })
          }
          required
        />

        <textarea
          placeholder="Full News"
          value={form.description}
          onChange={(e) =>
            setForm({ ...form, description: e.target.value })
          }
          required
        />

        <input
          type="date"
          value={form.news_date}
          onChange={(e) =>
            setForm({ ...form, news_date: e.target.value })
          }
          required
        />

        <input
          type="file"
          onChange={(e) => setImage(e.target.files[0])}
        />

        <div className="form-buttons">

          <button type="submit" className="btn btn-success">
            {editId ? "Update News" : "Add News"}
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            onClick={resetForm}
          >
            Reset
          </button>

        </div>

      </form>


      <table className="news-table">

        <thead>
          <tr>
            <th>ID</th>
            <th>Image</th>
            <th>Title</th>
            <th>Description</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {news.map((n) => (

            <tr key={n.id}>

              <td>{n.id}</td>

              <td>
                <img
                  src={`${BASE_URL}/uploads/news/${n.image}`}
                  alt={n.title}
                  className="news-thumb"
                />
              </td>

              <td className="title">{n.title}</td>

              <td className="descr">{n.description}</td>

              <td>{n.news_date}</td>

              <td>

                <button
                  className="edit-btn"
                  onClick={() => editNews(n)}
                >
                  Edit
                </button>

                <button
                  className="delete-btn"
                  onClick={() => deleteNews(n.id)}
                >
                  Delete
                </button>

              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
};

export default AdminNewsManager;